// removed by extract-text-webpack-plugin
module.exports = {"shy_tipsWarp":"shy_tipsWarp","shy_tipsText":"shy_tipsText","shy_tipsTips":"shy_tipsTips","bottom":"bottom","top":"top","light":"light","dark":"dark"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/sass/Unit/Tooltip_shy.scss
// module id = 255
// module chunks = 0